import { Grid } from '@mui/material';
import type { FC, MouseEvent as ReactMouseEvent } from 'react';
import { useNavigate } from 'react-router';

import { useZustand } from '../../zustandStore';

import { BodyText, StyledBulleList } from './commonComponents';

export const CookieIntroduction: FC = () => {
	const { setIsCookieCutterOpen } = useZustand(state => ({ ...state }));
	const navigate = useNavigate();

	const handleCookieNoticeClick = (e: ReactMouseEvent) => {
		e.preventDefault();
		setIsCookieCutterOpen(false);
		void navigate('/cookie-notice');
	};

	return (
		<Grid container spacing={2}>
			<Grid size={12}>
				<BodyText variant="subtitle1">
					We use cookies to help keep our website and services working properly. These cookies are necessary and are set
					automatically.
				</BodyText>
				<BodyText variant="subtitle1" sx={{ marginTop: 2 }}>
					We’d also like to use some optional cookies that:
				</BodyText>
				<StyledBulleList variant="subtitle1">Make your visit more personal</StyledBulleList>
				<StyledBulleList variant="subtitle1">Improve our website based on how you use it</StyledBulleList>
				<StyledBulleList variant="subtitle1">Support our marketing</StyledBulleList>

				<BodyText variant="subtitle1" sx={{ marginTop: 2 }}>
					You can either 'Accept' or 'Decline' these cookies or choose what cookies to accept in 'Manage cookies'.
				</BodyText>
				<BodyText variant="subtitle1">
					To learn more about how we use cookies, visit our{' '}
					<span style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={handleCookieNoticeClick}>
						Cookie Notice
					</span>
					.
				</BodyText>
			</Grid>
		</Grid>
	);
};
